export const dashboard = {
  title: 'Dashboard',
  subtitle: 'Business overview and statistics',
  welcome: {
    morning: 'Good morning, ',
    afternoon: 'Good afternoon, ',
    evening: 'Good evening, ',
    message: 'Welcome to the system!',
    motivationalMessages: [
      'You are ready for a successful day!',
      'Today is a great day!',
      'Today is full of opportunities!',
      'We are building the future together!',
      'The secret to success is in the initiative!',
      'Every great thing starts with small steps!',
      'The impossible becomes possible when you believe in it!',
      'Today is your day!',
      'Let\'s make the world better together!',
      'Excellence is not a goal, but a way of life!'
    ]
  },
  stats: {
    totalQuotations: 'Total quotations',
    activeCustomers: 'Active customers',
    successRate: 'Success rate',
    totalRevenue: 'Total revenue',
    totalContracts: 'Total contracts'
  },
  revenueOverview: 'Revenue overview',
  recentQuotations: 'Recent quotations',
  vsLastMonth: 'vs last month',
  expiringContracts: {
    title: 'Expiring contracts',
    noContracts: 'No expiring contracts',
    daysLeft: '{{count}} days left',
    days: '{{count}} days left',
    type: {
      contract: 'Contract',
      quotation: 'Quotation'
    }
  }
}